var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 13.999,
  viewBox: "0 0 16 13.999"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M14.891,16H1.109A1.11,1.11,0,0,1,0,14.89V10.909a.617.617,0,1,1,1.234,0V14.4a.369.369,0,0,0,.368.368H14.4a.369.369,0,0,0,.368-.368V10.911a.618.618,0,0,1,1.236,0V14.89A1.11,1.11,0,0,1,14.891,16Zm-6.873-4.38A.619.619,0,0,1,7.4,11V4.108L5.67,5.837a.616.616,0,0,1-.872,0,.621.621,0,0,1,0-.873L7.581,2.181a.619.619,0,0,1,.875,0l2.782,2.784a.617.617,0,1,1-.871.873L8.635,4.108V11A.619.619,0,0,1,8.018,11.618Z",
  transform: "translate(0 -2)",
  fill: "#898989"
})));
export default __webpack_public_path__ + "static/media/upload.c31724c8.svg";
export { SvgComponent as ReactComponent };